// Model.js
// -----------------------
// @module Case
define('TavanoTeamStaging.Feedback.Model', [
  'Backbone',
  'Utils',
  'underscore'
], function (
  Backbone,
  Utils,
  _
) {
  'use strict';

  // @class Case.Fields.Model @extends Backbone.Model
  return Backbone.Model.extend({
    //@property {String} urlRoot
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath(
        'Modules/Feedback/SuiteScript2/Feedback.Service.ss'
      ), true
    ),

    validation: {
      email: {
        required: false,
        pattern: 'email',
        msg: _('Valid Email is required').translate()
      },
      message: {
        required: true,
        msg: _('Feedback and suggestions are required').translate()
      },
    }
  });
});
